<template>
    <div class="apn-page apn-about">
        <!-- Banner -->
        <apn-banner :bg-image="BannerImg" :message="message" />
        <!-- Main -->
        <section class="section section--ours">
            <div class="apn-container">
                <article class="ours">
                    <div class="our our-service">
                        <h2>our service</h2>
                        <p>
                            {{$t('about.ourServices')}}<br>
                            {{$t('about.twenty4')}}
                        </p>
                    </div>
                    <div class="our our-strength">
                        <h2>our strength</h2>
                        <p>{{$t('about.strength')}}</p>
                    </div>
                </article>
                <div class="our-services-more">
                    <div class="more-service more-service--it-solution">
                        <p>NFS-I License holder since 2016</p>
                    </div>
                    <div class="more-service more-service--place">
                        <p>100% local based company <br> and was founded in 2015</p>
                    </div>
                    <div class="more-service more-service--money">
                        <p>Capital: Approx. 20 Million USD <br> (including capital reserve)</p>
                    </div>
                    <div class="more-service more-service--location">
                        <p>12 Branch Offices In Myanmar</p>
                    </div>
                    <div class="more-service more-service--setting1">
                        <p>Quality Services</p>
                    </div>
                    <div class="more-service more-service--money1">
                        <p>Resonable Price</p>
                    </div>
                    <div class="more-service more-service--verify">
                        <p>Value Added Services</p>
                    </div>
                </div>
            </div>
        </section>
        <section class="section section--members">
            <div class="apn-container">
                <h1>our team</h1>
                <div class="our-team">
                    <div class="team-photo">
                        <img src="../assets/images/about-us.jpeg" alt="">
                    </div>
                    <div class="about-team">
                        <h2>
                            We, Myanmar APN, have a group of
                            talented experts team and international
                            network of associates.
                        </h2>
                        <ul>
                            <li>Team with extremely academic background and hands on experiences</li>
                            <li>Team with customer oriented services</li>
                        </ul>
                    </div>
                </div>
            </div>
        </section>
        <section class="section section--showcase" v-if="showcase">
            <div class="apn-container apn-boxs">
                <div class="box">
                    <number
                        animationPaused
                        ref="number1"
                        :from="0"
                        :to="showcase[0].count"
                        :duration=".5"
                        easing="Power1.easeOut"/>
                    <strong>{{ showcase[0].name }}</strong>
                </div>
                <div class="box">
                    <number
                        animationPaused
                        ref="number2"
                        :from="0"
                        :to="showcase[1].count"
                        :duration=".8"
                        easing="Power1.easeOut"/>
                    <strong>{{ showcase[1].name }}</strong>
                </div>
                <div class="box">
                    <number
                        animationPaused
                        ref="number3"
                        :from="0"
                        :to="showcase[2].count"
                        :duration="1"
                        easing="Power1.easeOut"/>
                    <strong>{{ showcase[2].name }}</strong>
                </div>
                <div class="box">
                    <number
                        animationPaused
                        ref="number4"
                        :from="0"
                        :to="showcase[3].count"
                        :duration=".5"
                        easing="Power1.easeOut"/>
                    <strong>{{ showcase[3].name }}</strong>
                </div>
            </div>
        </section>
        <section class="section section--loading" v-else>
            <div class="lds-css ng-scope">
                <div style="width:100%;height:100%" class="lds-ellipsis">
                    <div><div></div></div>
                    <div><div></div></div>
                    <div><div></div></div>
                    <div><div></div></div>
                    <div><div></div></div>
                </div>
            </div>
        </section>
        <section class="section section--detail">
            <div class="apn-container">
                <img src="../assets/icons/c1.png" alt="c1" class="c1">
                <img src="../assets/icons/c2.png" alt="c2" class="c2">
                <img src="../assets/icons/c3.png" alt="c3" class="c3">
                <img src="../assets/icons/c5.png" alt="c4" class="c4">
                <img src="../assets/icons/c4.png" alt="c5" class="c5">
            </div>
        </section>
        <!-- Footer -->
        <apn-footer />
    </div>
</template>

<script>
import { mapState, mapActions } from "vuex"
import Vue from 'vue'
import VueNumber from 'vue-number-animation' 
Vue.use(VueNumber)

import ApnBanner from '@/components/ApnBanner'
import ApnFooter from '@/components/ApnFooter'
import BannerImg from '@/assets/images/about-banner.jpg'

export default {
    name: 'ApnAbout',
    components: {
        ApnBanner,
        ApnFooter,
    },
    data() {
        return {
            BannerImg,
            message: {
                header: 'About Us',
                content: `about.info`,
            },
            isAnimationStart: false,
        }
    },
    computed: {
        ...mapState({
            showcase: state => state.showcase,
        })
    },
    methods: {
        ...mapActions({
            getShowcase: 'getShowcase',
        }),
        playAnimation() {
            this.$refs.number1.play()
            this.$refs.number2.play()
            this.$refs.number3.play()
            this.$refs.number4.play()
        },
        onScroll() {
            if (this.isAnimationStart) return
            const scrollTop = window.scrollY
            const elm = this.$el.querySelector('.section--showcase')
            if (!elm) return
            if ((window.innerHeight / 1.5) + scrollTop >= elm.offsetTop) {
                this.playAnimation()
            }
        }
    },
    mounted() {
        this.getShowcase()
    },
    created () {
        window.addEventListener('scroll', this.onScroll)
    },
    destroyed() {
        window.removeEventListener('scroll', this.onScroll)
    }
}
</script>

<style lang="scss" scoped>
.apn-about {
    .section {
        padding: 40px 0;
        .apn-container {
            h1 {
                text-transform: uppercase;
                font-size: 42px;
                font-weight: 300;
                text-align: center;
                padding: 40px 0 20px;
                color: var(--primary);
                @media (min-width: 992px) {
                    font-size: 54px;
                }
            }
        }
    }
    .section--ours {
        padding-bottom: 60px;
        .ours {
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            align-items: flex-start;
            .our {
                width: 100%;
                display: flex;
                flex-direction: column;
                justify-content: flex-start;
                align-items: center;
                padding: 20px;
                max-width: 500px;
                @media (min-width: 992px) {
                    width: 50%;
                    max-width: 600px;
                }
                &::before {
                    content: '';
                    width: 80px;
                    height: 80px;
                    display: block;
                    margin: 20px;
                    background-size: contain;
                    background-position: center;
                    background-repeat: no-repeat;
                }
                &.our-service::before {
                    background-image: url(../assets/icons/our-services.png);
                    background-size: 60px;
                }
                &.our-strength::before {
                    background-image: url(../assets/icons/our-strength.png);
                }
                h2 {
                    text-transform: uppercase;
                    text-align: center;
                    font-size: 20px;
                }
                p {
                    text-align: center;
                }
            }
        }  
        .our-services-more {
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            align-items: flex-start;
            padding: 40px 0;
            .more-service {
                width: 100%;
                max-width: 295px;
                display: flex;
                flex-direction: column;
                justify-content: flex-start;
                align-items: center;
                &::before {
                    content: '';
                    width: 80px;
                    height: 80px;
                    display: block;
                    margin: 20px;
                    background-size: contain;
                    background-position: center;
                    background-repeat: no-repeat;
                }
                &.more-service--it-solution::before {
                    background-image: url(../assets/icons/it-solution.png);
                    background-size: 70px;
                }
                &.more-service--place::before {
                    background-image: url(../assets/icons/place.png);
                    background-size: 72px;
                }
                &.more-service--money::before {
                    background-image: url(../assets/icons/money.png);
                    background-size: 72px;
                }
                &.more-service--location::before {
                    background-image: url(../assets/icons/location.png);
                    background-size: 60px;
                }
                &.more-service--setting1::before {
                    background-image: url(../assets/icons/setting1.png);
                    background-size: 60px;
                }
                &.more-service--money1::before {
                    background-image: url(../assets/icons/money1.png);
                    background-size: 60px;
                }
                &.more-service--verify::before {
                    background-image: url(../assets/icons/verify.png);
                    background-size: 60px;
                }
                p {
                    text-align: center;
                }
            }
        } 
    }
    .section--members {
        background-color: var(--theme-bg);
        .our-team {
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            align-items: center;
            .team-photo {
                width: 100%;
                img {
                    width: 100%;
                    margin-bottom: -4px;
                }
                border: 1px solid var(--primary);
                @media (min-width: 768px) {
                    flex: 1;
                    max-width: 50%;
                    margin: 20px;
                }
            }
            .about-team {
                padding: 10px;
                @media (min-width: 768px) {
                    flex: 1;
                    padding: 20px;
                    h2 {
                        margin-top: -10px;
                    }
                }
                h2 {
                    font-size: 20px;
                    text-transform: uppercase;
                    padding-bottom: 20px;
                }
                ul {
                    margin: 0;
                    padding: 0;
                    list-style: none;
                    li {
                        display: flex;
                        align-items: center;
                        &::before {
                            content: '';
                            display: inline-block;
                            width: 2px;
                            height: 2px;
                            background-color: #333;
                            border-radius: 100%;
                            margin-right: 20px;
                        }
                    }
                }
            }
        }
    }
    .section--showcase {
        padding: 60px 0;
        background-color: var(--theme-bg);
        .apn-boxs {
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            align-items: flex-start;
            .box {
                width: 100%;
                max-width: 280px;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                padding: 40px 0;
                span {
                    display: block;
                    font-weight: 900;
                    font-size: 80px;
                    color: var(--footer-bg);
                }
            }
        }
    }
    .section--loading {
        min-height: 300px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .section--detail {
        .apn-container {
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            align-items: flex-start;
            max-width: 1000px;
            padding-top: 20px;
            img {
                width: 100%;
                max-width: 300px;
                margin: 0 0 -60px;
                @media (min-width: 576px) {
                    width: 50%;
                    &.c1 {
                        margin-right: -20px;
                    }
                    &.c2 {
                        margin-left: -20px;
                    }
                    &.c3 {
                        width: 290px;
                        margin-top: 20px;
                        margin-left: -20px;
                    }
                    &.c4 {
                        margin-left: -20px;
                    }
                    &.c5 {
                        margin-top: -20px;
                    }
                }
                @media (min-width: 992px) {
                    &.c1 {
                        margin-right: -40px;
                    }
                    &.c2 {
                        max-width: 320px;
                        margin-top: -10px;
                        margin-left: 0;
                    }
                    &.c3 {
                        margin-top: 5px;
                        margin-left: -40px;
                    }
                    &.c4 {
                        margin-left: 0;
                        margin-top: -15px;
                        margin-bottom: 0;
                    }
                    &.c5 {
                        margin-top: 0;
                        max-width: 270px;
                        margin-left: -40px;
                        margin-bottom: 0;
                    }
                }
            }
        }
    }
}
</style>

